import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors } from "@styles/index";

// Needs the !important in order to overwrite the disabled colour state in the TagButton component.
export const sellPrice = css`
  color: ${colors.blue.base};
  display: inline;
  font-weight: ${typography.weightSemiBold};

  .fa-bolt path {
    color: ${colors.blue.base} !important;
  }
`;

export const msrp = css`
  color: ${colors.grey.base};
  margin-right: 0.5rem;
`;

export const svg = css`
  margin-right: 0.25rem;
`;
